import { getRequiredDocuments } from 'prequalificationV2/utils/documentsUtils';
import { setRequiredDocuments } from 'prequalificationV2/actions/documents';
import { ApplicationType } from 'enums/ApplicationType';
import { ApplicationDto } from 'prequalificationV2/api/ApplicationApi';

export const updateDocuments = (borrowerApplication: ApplicationDto, dispatch: any) => {
  const applicationType = borrowerApplication?.coborrowerIds[0] ? ApplicationType.Joint : ApplicationType.Individual;

  const { borrower_first_name: borrowerFirstName, coborrower_first_name: coBorrowerFirstName } =
    borrowerApplication.variables;

  const requiredDocuments = getRequiredDocuments(
    borrowerApplication,
    borrowerFirstName!,
    coBorrowerFirstName || '',
    applicationType,
  );

  dispatch(
    setRequiredDocuments({
      requiredDocuments: requiredDocuments,
      applicationType: applicationType,
    }),
  );
};
